import { render, staticRenderFns } from "./account-settings.vue?vue&type=template&id=0f627119"
import script from "./account-settings.vue?vue&type=script&lang=js"
export * from "./account-settings.vue?vue&type=script&lang=js"
import style0 from "./account-settings.vue?vue&type=style&index=0&id=0f627119&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports